module.exports = __webpack_public_path__ + "bfda5ed4edb39e08103a5f3938f3b03a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-6.png
// module id = 2144
// module chunks = 0